import { useEffect, useState } from 'react'
import LogoV from '../../assets/images/coollogo_V.png';
import LogoS from '../../assets/images/coollogo_S.png';
import { Link } from 'react-router-dom'
import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import Loader from 'react-loaders';
import developer from '../../assets/images/developer.png';

const splitString = (str) => {
  return str.split('');
}

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const nameArray = splitString('aleria');
  const surnameArray = splitString('erci')
  const jobArray = splitString('Junior Software Developer')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);

    return () => {
      clearTimeout(timer);
    }  
  });
  
  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1> 
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>e</span>
            <span className={`${letterClass} _13`}>l</span>
            <span className={`${letterClass} _14`}>l</span>
            <span className={`${letterClass} _15`}>o</span>
            <span className={`${letterClass} _16`}>,</span>
            <span className={`${letterClass} _17`}> </span>
            
            <span className={`${letterClass} _18`}>I</span>
            <span className={`${letterClass} _19`}>'m</span>
            <br />
            
            
            <img className='logo' src={LogoV} alt="developer-name" />
            <AnimatedLetters letterClass={letterClass}
            strArray={nameArray}
            idx={22}
            />
            <img className='logo' src={LogoS} alt="developer-surname" />
            <AnimatedLetters letterClass={letterClass}
            strArray={surnameArray}
            idx={25}
            />
            <br />
            <div className='jobArray'>
              <AnimatedLetters  letterClass={letterClass}
              strArray={jobArray}
              idx={26}
            />
            </div>
          </h1>
          
          <Link to="/contact" className='flat-button'>CONTACT ME</Link>
        </div>
        <div>
          <img className='developer' src={developer} alt="developer" />
        </div>
      </div>
      <Loader type='pacman' />
    </>
  )
}

export default Home;